import type { JourneyEdge } from "@starsach/shared-types";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Rollups made before labels were readable carry the block's UUID; show the block's type from the node id instead of the UUID. */
export function readableLabel(label: string, nodeId: string): string {
  if (!UUID.test(label)) return label;
  const type = nodeId.split("#")[1];
  return type && !UUID.test(type) ? type : "Block";
}

/** "pressed 1", "Timeout", "Error" - how the source block chose this edge, when the rollup says. */
/** Connect's branch names as a person would say them: `1` → "pressed 1", `#` → "pressed #", `NotDone` → "Not done". */
export function branchText(edge: Pick<JourneyEdge, "branch">): string | undefined {
  if (!edge.branch) return undefined;
  if (/^(\d{1,2}|[*#])$/.test(edge.branch)) return `pressed ${edge.branch}`;
  const words = edge.branch.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function edgeTitle(edge: JourneyEdge): string {
  const b = branchText(edge);
  return `${readableLabel(edge.fromLabel, edge.from)} → ${readableLabel(edge.toLabel, edge.to)}${b ? ` (${b})` : ""}`;
}
